var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#F1F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9227 15.1386L9.39237 14.6083L9.9227 15.1386L14.531 10.5303C14.5497 10.5117 14.5685 10.4929 14.5874 10.4741C14.8011 10.2615 15.0247 10.039 15.1545 9.77703L14.4825 9.44402L15.1545 9.77703C15.3971 9.28742 15.3971 8.71258 15.1545 8.22297L14.4825 8.55598L15.1545 8.22297C15.0247 7.96101 14.8011 7.73852 14.5874 7.52588C14.5685 7.50707 14.5497 7.48834 14.531 7.46967L14.0007 8L14.531 7.46967C14.5123 7.451 14.4936 7.43218 14.4748 7.41328C14.2621 7.19958 14.0396 6.97599 13.7777 6.84618C13.2881 6.60356 12.7132 6.60356 12.2236 6.84618C11.9617 6.97599 11.7392 7.19958 11.5265 7.41328C11.5077 7.43218 11.489 7.451 11.4703 7.46967L6.86204 12.078C6.84947 12.0905 6.8368 12.1031 6.82405 12.1158C6.66779 12.2715 6.49978 12.4388 6.38077 12.649C6.26175 12.8592 6.20469 13.0894 6.15163 13.3035C6.1473 13.3209 6.143 13.3383 6.13869 13.3555L5.80849 14.6763C5.80587 14.6868 5.8032 14.6974 5.80048 14.7083C5.76265 14.8591 5.71628 15.0439 5.70063 15.2039C5.68295 15.3846 5.68137 15.7411 5.97047 16.0302C6.25956 16.3193 6.61607 16.3177 6.79678 16.3C6.95673 16.2844 7.14159 16.238 7.29239 16.2002C7.30322 16.1974 7.31388 16.1948 7.32434 16.1922L8.64512 15.862C8.66236 15.8577 8.67972 15.8534 8.6972 15.849C8.91126 15.796 9.14142 15.7389 9.35162 15.6199C9.56183 15.5009 9.72917 15.3329 9.8848 15.1766C9.89751 15.1639 9.91013 15.1512 9.9227 15.1386Z",
    stroke: "#666666",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 8.00033L13.334 6.66699L15.334 8.66699L14.0007 10.667L11.334 8.00033Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.77f3db1333ceb0e45613441c0b4eb1e2.svg";
export { ForwardRef as ReactComponent };